module.exports = __webpack_public_path__ + "media/images/icons_enabled_sprite-4822b982.svg";